import { indexData } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'hover:bg-primary-50', text: 'text-foreground-950', iconBg: 'bg-primary-100 text-primary-600' },
  accent: { bg: 'hover:bg-accent-50', text: 'text-foreground-950', iconBg: 'bg-accent-100 text-accent-600' },
  secondary: { bg: 'hover:bg-secondary-50', text: 'text-foreground-950', iconBg: 'bg-secondary-100 text-secondary-600' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            专题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按品类快速找到你感兴趣的漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {indexData.slice(0, 9).map((item) => {
            const c = colorMap[item.color] || colorMap.primary;
            return (
              <a
                key={item.name}
                href="#ranking"
                className={`flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 ${c.bg} transition-colors cursor-pointer`}
              >
                <div className={`w-10 h-10 rounded-lg ${c.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </div>
                <div className="min-w-0">
                  <h3 className={`text-sm font-medium ${c.text} truncate`}>{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}